var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendaricon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.a,.b{stroke:#00686f;stroke-miterlimit:10;}.b{stroke-linecap:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 12,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 15,
    transform: "translate(0.5 5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 2,
    transform: "translate(4.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 2,
    transform: "translate(11.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendar.icon.c639978b378f7b7359051293e0566744.svg";
export { ForwardRef as ReactComponent };